"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstrumentPropertyValueByInstrumentId = void 0;
var getInstrumentPropertyValueByInstrumentId = exports.getInstrumentPropertyValueByInstrumentId = function getInstrumentPropertyValueByInstrumentId(instruments, instrumentId, propertyName) {
  var instrument = instruments.find(function (item) {
    return item.InstrumentId === instrumentId;
  });
  return instrument ? instrument[propertyName] : '';
};